var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer",attrs:{"id":"footer_wrap"}},[_c('footer',{staticClass:"inner"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.support)}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.copyright))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9bf4b90","hasScoped":false,"transformToRequire":{"img":["src","data-src"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 99
// module chunks = 0